import React, { useContext, useState, useMemo } from 'react'
import { Context } from '../../../../Store'
import { UserContext } from './../../../../utils/UserContext'
import { Grid, Select, InputLabel, FormControl, MenuItem } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { BOOKING_STATUS, PAYMENT_TYPE } from '../../../../constants'

export const SelectPaymentType = () => {
  const [{ booking, payment_type }, dispatch] = useContext(Context)
  const { user = {} } = useContext(UserContext)
  const [paymentType, setPaymentType] = useState(payment_type)
  const { t } = useTranslation()

  const onChangePaymentType = (event) => {
    dispatch({ type: 'SET_PAYMENT_TYPE', payload: event.target.value })
    setPaymentType(event.target.value)
  }

  return (
    <>
      <Grid item xs={12} lg={11}>
        <FormControl fullWidth variant="outlined">
          <InputLabel>{t('booking.paymentInfo.typePayment.placeholder')}</InputLabel>
          <Select
            name="payment_type"
            label={t('booking.paymentInfo.typePayment.placeholder')}
            onChange={onChangePaymentType}
            value={paymentType}
            disabled={booking.status === BOOKING_STATUS.PENDING}
          >
            <MenuItem key={PAYMENT_TYPE.CARD} value={PAYMENT_TYPE.CARD}>
              {t('booking.paymentInfo.typePayment.card')}
            </MenuItem>
            <MenuItem key={PAYMENT_TYPE.BANK_TRANSFER} value={PAYMENT_TYPE.BANK_TRANSFER}>
              {t('booking.paymentInfo.typePayment.banktransfer')}
            </MenuItem>
          </Select>
        </FormControl>
      </Grid>
    </>
  )
}
